import { Typography } from '@mui/material'
import Button from '@mui/material/Button'
import { FC } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useInvalidateCollaborationAppMeetingQuery } from '../../api/hooks/useInvalidateCollaborationAppMeetingQuery'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { useAssistantAdministrationStore } from '../../store/storeAssistantAdministration'

type Props = {
    open: boolean
    handleClose: VoidFunction
    id?: string
}

export const MeetDeleteDialog: FC<Props> = ({ open, handleClose, id }) => {
    const [searchParams] = useSearchParams()
    const invalidateMeetings = useInvalidateCollaborationAppMeetingQuery()

    const { removeRecordingMeeting, fetchMeeting, isLoadingRemoveMeeting, errorRemoveMeeting } =
        useAssistantAdministrationStore((state) => state)

    const handleClickRemove = async () => {
        await removeRecordingMeeting({ meetingId: id })
        if (!errorRemoveMeeting) {
            invalidateMeetings()
            await fetchMeeting({ status__in: searchParams.get('status') })
            handleClose()
        }
    }

    return (
        <ModalDialogWrapper
            open={open}
            sx={{
                '.MuiPaper-root': {
                    width: '501px',
                    maxWidth: '501px',
                },
            }}
            footerActions={
                <>
                    <Button
                        fullWidth
                        onClick={handleClose}
                        variant="outlined"
                        color="primary"
                        disabled={isLoadingRemoveMeeting}>
                        Отменить
                    </Button>
                    <Button
                        fullWidth
                        onClick={handleClickRemove}
                        variant="contained"
                        disabled={isLoadingRemoveMeeting}>
                        Удалить
                    </Button>
                </>
            }
            handleClose={handleClose}
            title="Удалить встречу?">
            <Typography variant="body2" color="#1B1C1D">
                Встреча будет удалена. Придется ее создавать заново
            </Typography>
        </ModalDialogWrapper>
    )
}
